<template>
  <section class="Quiz_section QuizText">
    <div class="Quiz_section_wrapper">
      <figure class="Quiz_illustration" v-if="data.illustration">
        <div class="Quiz_illustration_image Quiz_illustration_image_bodymovin" v-if="data.illustration.endsWith('.json')" ref="bodymovin" :style="{ opacity: lottieLoaded ? 1 : 0 }"></div>
        <img class="Quiz_illustration_image" :src="data.illustration" v-else/>
      </figure>

      <div class="Quiz_content">
        <transition name="bottom" appear>
          <h3 class="Quiz_title" v-html="data.tag" v-if="data.tag"></h3>
        </transition>
        <transition name="bottom" appear>
          <h4 class="Quiz_question" v-html="data.label" v-if="data.label"></h4>
        </transition>
        <transition name="bottom" appear>
          <p class="Quiz_indic" v-html="data.content" v-if="data.content"></p>
        </transition>

        <transition :name="$tools.isMobile() ? 'bottom' : null" appear>
          <button class="Cta Quiz_cta" @click="$emit('nextQuestion')" v-if="template == 'screening'">C'est parti <i class="far fa-arrow-right"></i></button>
          <button class="Cta Quiz_cta" @click="$emit('nextQuestion')" v-else-if="template == 'qualiscore'">Je commence l'évaluation <i class="far fa-arrow-right"></i></button>
          <button class="Cta Quiz_cta" @click="$emit('nextQuestion')" v-else-if="template == 'annexe'">Suivant <i class="far fa-arrow-right"></i></button>
          <button class="Cta Quiz_cta" @click="$emit('closeQuiz')" v-else>Je découvre mon Qualiscore <i class="far fa-arrow-right"></i></button>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
  import page from '@/mixins/page'
  import lottie from 'lottie-web'

  export default {
    name: "QuizText",
    mixins: [ 'page' ],
    props: [ 'data', 'template' ],
    data() {
      return {
        anim: null,
        lottieLoaded: false
      }
    },
    mounted()
    {
      if(this.data.illustration && this.data.illustration.endsWith(".json"))
      {
        this.anim = lottie.loadAnimation({
          container: this.$refs.bodymovin,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: this.data.illustration
        });

        this.anim.addEventListener('DOMLoaded', () => { this.lottieLoaded = true })
      }

      document.body.querySelector('.QuizBackground').classList.remove('QuizBackground_withIllustration')

      if(this.template != 'annexe')
      {
        document.body.querySelector('.Header').classList.add('Header_withTitle')
        document.body.querySelector('.QuizBackground').classList.add('QuizBackground_white')
      }
    },
    beforeDestroy()
    {
      document.body.querySelector('.QuizBackground').classList.remove('QuizBackground_white')
    }
  }
</script>

<style lang="stylus" scoped>

  .Quiz_section

    display flex
    flex-direction column
    align-items center

  .Quiz

    &_question

      @media $xsmall

        font-size 18px
        line-height 22px

    &_indic

      font-size 18px
      line-height 24px

    &_illustration

      @media $medium
      
        margin-bottom 60px

      @media $small
      
        margin-bottom auto

    &_content

      margin 0px auto auto auto

    .Cta

      margin-top 60px

    &_title

      color $red
      
</style>